export default __webpack_public_path__ + "static/media/LeftThumbSlider.3de0723f.svg";